export default __webpack_public_path__ + "static/media/image3.b632fe3d.png";